import React, { useState, useEffect, useRef } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { format, subDays } from 'date-fns';

const AutocompleteIssueTimestamp = ({ cqlFechaMax, cqlFechaMin, handleBackdropOpen, handleBackdropClose, handleDateSelect }) => {
  const [issueTimeOptions, setIssueTimeOptions] = useState([]);
  const [defaultIssueTime, setDefaultIssueTime] = useState(null);
  const [isUserInteraction, setIsUserInteraction] = useState(false); // Estado para diferenciar interacción manual

  useEffect(() => {
    handleBackdropOpen();

    // Generar las fechas fijas: D-0, D-1, D-2 en formato 'yyyy-MM-dd'
    const dates = [0, 1, 2].map(daysAgo => {
      const date = subDays(new Date(cqlFechaMin), daysAgo);
      return {
        label: `D-${daysAgo}: ${format(date, 'yyyy-MM-dd')}`,
        value: format(date, 'yyyy-MM-dd')
      };
    });

    setIssueTimeOptions(dates);

    // Seleccionar la primera opción automáticamente si no ha sido una interacción manual
    if (dates.length > 0 && !isUserInteraction) {
      setDefaultIssueTime(dates[0]);
      handleDateSelect(dates[0].value);
    }

    handleBackdropClose();
  }, [cqlFechaMax, cqlFechaMin, handleBackdropOpen, handleBackdropClose, handleDateSelect, isUserInteraction]);

  const handleManualChange = (event, newValue) => {
    setIsUserInteraction(true); // Marcar como interacción manual
    setDefaultIssueTime(newValue); // Permitir la selección manual del usuario
    handleDateSelect(newValue.value); // Llamar a handleDateSelect con la fecha seleccionada
  };

  // Reiniciar `isUserInteraction` cuando `cqlFecha` o `cqlFechaMin` cambien
  useEffect(() => {
    setIsUserInteraction(false);
  }, [cqlFechaMax, cqlFechaMin]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', marginTop: '10px' }}>
      <Autocomplete
        options={issueTimeOptions}
        getOptionLabel={(option) => option.label}
        value={defaultIssueTime}
        onChange={handleManualChange} // Cambiar solo al seleccionar manualmente
        disableClearable
        renderInput={(params) => (
          <TextField
            {...params}
            label="Issue Date"
            variant="outlined"
            sx={{
              backgroundColor: '#f5f5f5',
              borderRadius: '8px',
              boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
              '.MuiInputBase-input': {
                padding: '10px',
                color: '#333',
                userSelect: 'none',
                pointerEvents: 'none',
              },
              '.MuiOutlinedInput-notchedOutline': {
                borderColor: '#1976d2',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#115293',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#1976d2',
              },
            }}
          />
        )}
        sx={{
          width: 180,
          '.MuiAutocomplete-endAdornment': {
            '.MuiSvgIcon-root': {
              color: '#1976d2',
            },
          },
        }}
      />
    </Box>
  );
};

export default AutocompleteIssueTimestamp;
